module.exports = __webpack_public_path__ + "static/img/trans.52d8174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/trans.jpg
// module id = SfFK
// module chunks = 15